/* LiberLive App — Sticky Scroll. Per-instance, cleans up on section unload. */
(function () {
  function headerOffset() {
    var css = getComputedStyle(document.documentElement);
    var vars = ['--sticky-header-height', '--header-height', '--header-bottom-position'];
    for (var i = 0; i < vars.length; i++) {
      var v = parseFloat(css.getPropertyValue(vars[i]));
      if (v && v > 0) return v;
    }
    var el = document.querySelector('.section-header, sticky-header, header[role="banner"], #shopify-section-header');
    if (el) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') return el.getBoundingClientRect().height || 0;
    }
    return 0;
  }

  function init(root) {
    if (!root || root.__llapsc) return;
    var inst = {};
    root.__llapsc = inst;

    var track = root.querySelector('.llap-sc__track');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.llap-sc__card'));
    var screens = Array.prototype.slice.call(root.querySelectorAll('[data-screen]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.llap-sc__raildot'));
    var fill = root.querySelector('[data-railfill]');
    var slides = root.querySelector('[data-slides]');
    var mdots = Array.prototype.slice.call(root.querySelectorAll('.llap-sc__dot'));
    var n = parseInt(root.getAttribute('data-count'), 10) || screens.length;
    if (!n) return;

    var current = -1;
    function setActive(i) {
      i = Math.max(0, Math.min(n - 1, i));
      if (i === current) return;
      current = i;
      screens.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      cards.forEach(function (c) { var ci = +c.getAttribute('data-card'); var on = ci === i; c.classList.toggle('is-active', on); var b = c.querySelector('.llap-sc__cardbtn'); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (fill) fill.style.height = (n > 1 ? (i / (n - 1)) * 100 : 100) + '%';
    }

    /* ---- desktop scroll scrubbing ---- */
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!track || getComputedStyle(track).display === 'none') return;
        var top = headerOffset();
        var rect = track.getBoundingClientRect();
        var vh = window.innerHeight - top;
        var scrollable = rect.height - vh;      // distance the sticky scrubs over
        if (scrollable <= 0) { setActive(0); return; }
        var passed = (top - rect.top);          // how far we've scrolled into the track
        var p = Math.max(0, Math.min(1, passed / scrollable));
        var idx = Math.min(n - 1, Math.floor(p * n + 0.0001));
        setActive(idx);
      });
    }
    inst.onScroll = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    /* card / dot click -> scroll to that chapter */
    function scrollToIndex(i) {
      if (!track) return;
      var top = headerOffset();
      var vh = window.innerHeight - top;
      var scrollable = track.offsetHeight - vh;
      var y = window.pageYOffset + track.getBoundingClientRect().top - top + (scrollable * ((i + 0.5) / n));
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    root.querySelectorAll('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { scrollToIndex(+b.getAttribute('data-goto')); });
    });

    /* ---- mobile carousel: sync dots with scroll, dot click scrolls ---- */
    if (slides) {
      var mTick = false;
      function onSlide() {
        if (mTick) return; mTick = true;
        requestAnimationFrame(function () {
          mTick = false;
          var center = slides.scrollLeft + slides.clientWidth / 2;
          var best = 0, bestD = Infinity;
          var items = slides.querySelectorAll('.llap-sc__slide');
          items.forEach(function (it, k) {
            var c = it.offsetLeft + it.offsetWidth / 2;
            var d = Math.abs(c - center);
            if (d < bestD) { bestD = d; best = k; }
          });
          mdots.forEach(function (d, k) { var on = k === best; d.classList.toggle('is-active', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); });
        });
      }
      inst.onSlide = onSlide; inst.slides = slides;
      slides.addEventListener('scroll', onSlide, { passive: true });
      mdots.forEach(function (d) {
        d.addEventListener('click', function () {
          var k = +d.getAttribute('data-mdot');
          var item = slides.querySelectorAll('.llap-sc__slide')[k];
          if (item) slides.scrollTo({ left: item.offsetLeft - (slides.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
        });
      });
    }

    setActive(0);
    onScroll();
  }

  function destroy(root) {
    var inst = root && root.__llapsc;
    if (!inst) return;
    if (inst.onScroll) { window.removeEventListener('scroll', inst.onScroll); window.removeEventListener('resize', inst.onScroll); }
    if (inst.slides && inst.onSlide) inst.slides.removeEventListener('scroll', inst.onSlide);
    root.__llapsc = null;
  }

  function boot() { document.querySelectorAll('[data-llap-sc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-llap-sc]'); if (el) init(el); });
  document.addEventListener('shopify:section:unload', function (e) { var el = e.target.querySelector('[data-llap-sc]'); if (el) destroy(el); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-llap-sc]'); if (!root || !root.__llapsc) return;
    var card = e.target.closest('[data-card]'); if (card) { /* no-op scrub in editor */ }
  });
})();
